module.exports = __webpack_public_path__ + "img/RectangleSecretKey.1ab845fd.png";